export default __webpack_public_path__ + "locales/sk/Common.json?hash=c6e4e50498857513ab98ad2d25312707";